import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { SortType } from '@swimlane/ngx-datatable';
import * as _moment from "moment";
import { Moment } from "moment";
import { OwlDateTimeComponent } from 'ng-pick-datetime';
import { Papa, ParseResult } from 'ngx-papaparse';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Observable } from 'rxjs';
import { TipoArchivoImportacion } from 'src/app/helpers/TipoArchivoImportacion.enum';
import { Emisor } from 'src/app/models/Emisor/Emisor';
import { ImportacionFilter } from 'src/app/models/MassInvoicing/ImportacionFilter';
import { ImportacionMasiva } from 'src/app/models/MassInvoicing/ImportacionMasiva';
import { SolicitudFacturacionMasiva } from 'src/app/models/SolicitudFacturacionMasiva';
import { TipoDte } from 'src/app/models/tipoDte';
import { EmisorService } from 'src/app/services/emisor.service';
import { FacturadorMasivoService } from 'src/app/services/facturador-masivo.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { PermissionService } from 'src/app/services/permission.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { VerificacionCertificadoService } from 'src/app/services/verificacion-certificado.service';
import { Page } from 'src/app/shared/models/Page';
import { PagedResponse } from 'src/app/shared/models/PagedResponse';
import { SessionUser } from 'src/app/shared/models/sessionUser';
import { environment } from 'src/environments/environment';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import * as FileSaver from "file-saver";
import { Response } from "src/app/shared/models/Response";
import { BheService } from 'src/app/services/bhe.service';
import { ConfigFacturaMasiva } from './config-facturador-masivo';
import { ImportacionMasivaBHE } from 'src/app/models/MassInvoicing/ImportacionMasivaBHE';
import { FacturadorMasivoBHEService } from 'src/app/services/facturador-masivo-bhe.service';
import { ImportacionResultadoBHE } from 'src/app/models/MassInvoicing/ImportacionResultadoBHE';
import { map } from 'rxjs/operators';
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';
const moment = (_moment as any).default ? (_moment as any).default : _moment;
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
@Component({
  selector: 'app-mantenedor-bhe-masivo',
  templateUrl: './mantenedor-bhe-masivo.component.html',
  styleUrls: ['./mantenedor-bhe-masivo.component.scss']
})
export class MantenedorBheMasivoComponent implements OnInit {

  SortType = SortType;
	public configLocal = ConfigFacturaMasiva;
	public loading: boolean = false;
	rowsMantenedor: ImportacionMasivaBHE[] = [];
	public searchRows: any[] = [];
	public searchCriteria;
	private saveRows: boolean = false;
	public dteFileForm: FormGroup;
	public configScroll: PerfectScrollbarConfigInterface = {};
	public files: File[] = [];
	public empresasSource: Emisor[];
	public tipoDteSource;
	private addModal: NgbModalRef;
	private detailModal: NgbModalRef;
	public validFile: boolean = false;
	public resultStringData: string = "";
	public fileData: Object[];
	public resultedFileDataDocuments: any[];
	public numberOfDocumentosToSend: number;
	public sumOfDocumentDetails: number;
	public sumaResumenDocumento: [number, number];
	public ivaTotal: number;
	public totalFinal: number;
	public resultData: string = "";
	public emisorId: string;
	public currentEmisor: Emisor;
	public currentUser = this.tokenStorage.getUser() as SessionUser;
	public DetailString = "";
	public invalidColumns: Array<string> = [];
	public invoiceRequestDate: any;
	public dateFrom: any = moment();
	public dateTo: any = moment();
	public dateToday: any = moment();
	public page: Page = new Page();
	public filter: ImportacionFilter = new ImportacionFilter();
	public selectedImportacion: ImportacionMasivaBHE;
	public validationMessage: string = "";
	public dateMatrixRequest: any = moment();
	public todayString = moment();
	public componentStarted: boolean = false;
	public wrongDelimiter: boolean = false;
	public sucursalId: string = this.tokenStorage.getSubsidiary();

  fileIdState: Observable<object>;
	fileIdValue: string;

	@ViewChild("tableMobile") tableRef: any;
	locale = {
		daysOfWeek: moment.weekdaysMin(),
		monthNames: moment.monthsShort(),
		firstDay: moment.localeData().firstDayOfWeek(),
		applyLabel: "ok",
		clearLabel: "Limpiar",
		format: "DD/MM/YYYY",
	};
	//validation elements
	//Keys
	private validationKeysStandard = [
		"Id",
    "Retencion",
    "Tercero",
    "Dirección Emisor",
		"FechaEmision",
		"RutRecep",
    "RazonSocialRecep",
    "DireccionReceptor",
		"ComunaReceptor",
    "CodigoRegionReceptor",
		"Nombre Prestacion",		
		"Total",
    "RutAutorizado"
	];

  private validationKeysArray: Array<string> = this.validationKeysStandard;
	@ViewChild("summaryModal") private summaryModal: TemplateRef<any>;
	@ViewChild("confirmSwal") private confirmSwal: SwalComponent;
	@ViewChild("currentSwal") private currentSwal: SwalComponent;

	private innerSummaryRef: NgbModalRef;
	private currentSucursal = this.tokenStorage.getSubsidiary();
	public validDate: boolean = true;
	public superAdm = false;
	constructor(
		private formBuilder: FormBuilder,
    	public activatedRoute: ActivatedRoute,
		private modalService: NgbModal,
		private papaParser: Papa,
		private tokenStorage: TokenStorageService,
		private localStorage: LocalStorageService,
		private router: Router,
		private ref: ChangeDetectorRef,
		public utilities: UtilitiesService,
		public permissions: PermissionService,
		private emisorService: EmisorService,
    private bheService: FacturadorMasivoBHEService,
		private sessionUserService: SessionUserService, private planUsuarioService: PlanUsuarioService
	) {
		this.superAdm = this.tokenStorage.getUser().superAdmin;
		this.empresasSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		if (this.superAdm) {
			this.getEmisoresFullList();
		}
	}

	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		this.emisorId = this.tokenStorage.getCompany();
		this.currentEmisor = this.empresasSource.find((empresa) => empresa.emisorId == this.emisorId);
		//this.searchElements(this.emisorId);
		this.filter.emisorId = this.emisorId;
		this.filter.sucursalId = this.currentSucursal;
		this.tipoDteSource = JSON.parse(this.localStorage.getDteTypes()) as TipoDte[];
		this.setPage({ offset: 0 });
		const planActual = this.planUsuarioService.getActualPlan();
		if (planActual?.idPlanUsuario) {
			this.planUsuarioService.getCurrentDocuments(planActual.idPlanUsuario).subscribe({
				next: (result) => {
					if (result?.maxdtes === 0) {
						Swal.fire({
							icon: "warning",
							title: "Acceso no permitido",
							text: "Su plan actual (Sólo DTE Recibidos) no permite la emisión de documentos tributarios electrónicos. Será redirigido al mantenedor de documentos recibidos.",
							confirmButtonText: "Aceptar",
						}).then(() => {
							this.router.navigateByUrl("compras/documentos-recibidos");
						});
					}
				}
			});
		}

		this.createForm();
		this.saveRows = false;
	}

	changeSearchedRows(data) {
		if (data != null) {
			this.rowsMantenedor = data;
		}
	}

	f() {
		return this.dteFileForm.controls;
	}

	ngAfterViewChecked() {
		if (!this.saveRows && (this.rowsMantenedor[0] != undefined || this.rowsMantenedor[0] != null)) {
			this.searchRows = this.rowsMantenedor;
			this.saveRows = true;
		}
	}

	downloadFile(id: string) {
		this.loading = true;
		this.bheService
			.getFile(id)
			.subscribe(
				(res) => {
					let uint8Array = res.data as Uint8Array;
					let b64Response = res.data;
					//obtained  8bit array from response that need to be transformed into a Blob
					try {
						const blobCsv = this.utilities.convertB64ToBlob(b64Response, "text/csv");
						FileSaver.saveAs(blobCsv, "lista_de_facturas.csv");
					} catch (error) {
						this.setSwalAndFire(this.currentSwal, "error", "Error en Archivo", "No fue posible obtener el archivo CSV, favor contactar al administrador\n" + error);
					}
				},
				(error) => {
					this.setSwalAndFire(this.currentSwal, "error", "Error", "Error al obtener el archivo. Intente más tarde." + this.utilities.setErrorMessageFromArray(error.error));
				}
			)
			.add(() => {
				this.loading = false;
				this.ref.detectChanges();
			});
	}

	detail(detailModal, row: ImportacionMasivaBHE) {
		this.loading = true;
		this.selectedImportacion = row;
		this.bheService.getDetail(row.importacionMasivaId).subscribe(
      (result: Response<ImportacionResultadoBHE>) => {
        let resumen = result.data.resumen;
        let detalle = result.data.detalle;

        if (resumen) {
          this.resultData = resumen;
        }

        if (detalle) {
          // Reemplazar saltos de línea por <br> para mostrar en HTML
          this.DetailString = detalle.replace(/\n/g, "<br>");
          this.resultStringData = detalle;
        }

        // Abrir el modal después de asignar los datos
        this.detailModal = this.modalService.open(detailModal, {
          windowClass: "",
          size: "lg",
          centered: true,
        });
      },
      (error) => {
        console.log(error);
        this.setSwalAndFire(
          this.currentSwal,
          "error",
          "Error",
          "No es posible mostrar los detalles del Archivo en este momento, favor contactar al administrador.\n " + this.utilities.setErrorMessageFromArray(error.Errors || [error.Message || 'Error desconocido.'])
        );
      },
      () => {
        this.loading = false;
        this.ref.detectChanges();
      }
    );
	}

	relatedDtes(row: ImportacionMasiva) {
		let id = row.importacionMasivaId;
		let datePipe = new DatePipe("es-ES");
		let fechaCarga = datePipe.transform(row.fechaCarga, "dd-MM-yyyy");
		let horaCarga = datePipe.transform(row.fechaCarga, "HH:mm");
		let filterDescription = row.nombreUsuario + " con fecha " + fechaCarga + " a las " + horaCarga;
		this.router.navigateByUrl("ventas/boletas-honorarios-emitidas", {
      state: {
        paramId: id,
        filterDescription: "Emisión masiva generada por " + filterDescription,
        filterEmisor: this.filter.emisorId,
        filterSucursal: this.filter.sucursalId,
      },
    });
	}

	openAddDteFileModal(addNewModal) {
		if (!(this.permissions.getPermission("80-16").asignado)) { return; }
		this.files = [];
		this.addModal = this.modalService.open(addNewModal, {
			windowClass: "custom-modal",
			size: "lg",
		});
	}

  onSubmitMasivo() {
		this.wrongDelimiter = false;
		if (this.dteFileForm.invalid) {
			return;
		}
		//proccess the first element on files array with the parser
		this.papaParser.parse(this.files[0], {
			header: true,
			delimiter: ";",
			complete: (result) => {
				//PRE-CHECKER IF DATA COME WITH COMMENTS
				this.wrongDelimiter = result.meta.delimiter == "," && this.checkConflictInDelimiter(result);
				this.checkConflictInDelimiter(result);

				let cleanData = result.data.filter((obj) => obj["Id"] != "");			

				//CSV FILE VALIDATION START
				this.validFile = this.CsvValidation(cleanData, this.validationKeysArray);
				//if file is not valid, create Resume of invalid data
				if (!this.validFile) {
					let nameOfCurrentProperties = Object.keys(cleanData[0]);
					this.invalidColumns = nameOfCurrentProperties.filter((propertyName) => !this.validationKeysArray.includes(propertyName));
				} else if (this.validFile) {
					this.invalidColumns = [];
				}
				this.fileData = cleanData;
				let documentsByDetail = this.sortByProperty(this.fileData, "Id");
				this.resultedFileDataDocuments = documentsByDetail;
				this.numberOfDocumentosToSend = Object.keys(this.resultedFileDataDocuments).length;
				let sumResult = this.sumArrayProperty(this.fileData, "Total");
				//SUMA DE NETOS AFECTOS Y EXENTOS
				let sumaResumen: [number, number] = this.getSumAfectosExentos(this.fileData, "Total");
				if (sumaResumen && sumaResumen[0] != null && sumaResumen[1] != null) {
					this.totalFinal = sumaResumen[0] + sumaResumen[1];
				}
				this.sumaResumenDocumento = sumaResumen;
				this.sumOfDocumentDetails = sumResult;
				this.ref.detectChanges();
				//CSV FILE VALIDATION END
			},
		});
		//this.loading = true;
		this.onConfirmation(this.summaryModal);
	}

	onConfirmation(summaryModal) {
		this.innerSummaryRef = this.modalService.open(summaryModal, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}

	createForm() {
		this.dteFileForm = this.formBuilder.group({
			file: [null, Validators.required]
		});
	}

	onSelect(event) {
		if (event.rejectedFiles[0] || this.getName(event) != "csv") {
			this.setSwalAndFire(this.currentSwal, "error", "Error de Archivo", "El archivo ingresado no es de formato CSV, favor agregar un archivo con el formato correcto. Razón: " + event.rejectedFiles[0].reason == "size" ? "Tamaño" : "Tipo de archivo");
		}

		this.files.push(...event.addedFiles);
		if (this.files.length > 1) {
			this.files.shift();
		}
		this.dteFileForm.patchValue({ file: this.files[0] });

    this.onSubmitMasivo();
	}
	onRemove(event) {
		this.files.splice(this.files.indexOf(event), 1);
	}

	getName(event): string {
		if (event.addedFiles) {
			return event.addedFiles[0].name.split(".").pop();
		} else if (event.rejectedFiles) {
			return event.rejectedFiles[0].name.split(".").pop();
		} else {
			return "";
		}
	}

	confirmSwalOpener() {
		this.setSwalAndFire(this.confirmSwal, "info", "Ejecutar Facturación", "¿Está seguro de emitir las boletas de honorarios indicadas en el archivo?");
	}
	onCancelUpload() {
		this.modalService.dismissAll();
		this.dteFileForm.reset();
	}

	onUpload() {
		if (!(this.permissions.getPermission("80-16").asignado)) { return; }
		this.modalService.dismissAll();
		this.addModal.close();
		let emisionMasivaString = {};
		emisionMasivaString["CantidadSolicitada"] = this.fileData.length;
		let solicitud: SolicitudFacturacionMasiva = new SolicitudFacturacionMasiva();
		solicitud.emisorId = this.tokenStorage.getCompany();
		solicitud.sucursalId = this.tokenStorage.getSubsidiary();
		solicitud.cantidadSolicitada = this.fileData.length;
		solicitud.usuarioId = this.currentUser.id;
		this.loading = true;
		this.bheService.uploadMassiveFile(solicitud, this.files[0])
				.subscribe(
				(result) => {
					this.loading = false;
					this.ref.markForCheck();
					this.setPage({ offset: 0 });
					let message = result.message;
					this.setSwalAndFire(this.currentSwal, "success", "Facturación Exitosa", "Se han facturado los documentos solicitados \n\n " + message);
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
          let errorStrings: string[] = ["Error desconocido."];
        
          if (error.error) {
            // Intenta mapear la respuesta de error a la interfaz definida
            const errorResponse = error.error as Response<ImportacionMasivaBHE>;
            
            if (errorResponse && errorResponse.data && errorResponse.data.results) {
              // Filtrar los resultados que no fueron exitosos
              const failedResults = errorResponse.data.results.filter(result => !result.success);
              
              if (failedResults.length > 0) {
                // Extraer los mensajes de error
                errorStrings = failedResults.map(result => `ID: ${result.id} - ${result.message}`);
              } else if (errorResponse.message) {
                // Si no hay resultados fallidos, usa el mensaje general
                errorStrings = [errorResponse.message];
              }
            } else if (errorResponse.message) {
              // Si la estructura no es la esperada pero hay un mensaje
              errorStrings = [errorResponse.message];
            }
          }
          
          // Construir el string completo de errores en formato HTML
          let completeErrorString = "";
          errorStrings.forEach((errorStr) => {
            completeErrorString += "<p>" + errorStr + "</p>";
          });
					Swal.fire({
						icon: "error",
						title: "Error de Facturación",
						showCloseButton: true,
						html: "<div style='text-align:left;'>No fue posible completar el proceso de facturación. <br>Detalle:<br>" + completeErrorString + "</div>",
					});
				}
			)
			.add(() => {
				this.resetFormFacturacion();
				this.loading = false;
				this.ref.detectChanges();
        this.setPage({ offset: 0 });
			});
	}

	onShowResults() {}

	setSwalAndFire(swalReference: SwalComponent, iconString: SweetAlertIcon, titleString: string, textString: string) {
		swalReference.icon = iconString;
		swalReference.title = titleString;
		swalReference.text = textString;
		swalReference.fire();
	}

  CsvValidation(fileResult, keyArray): boolean {
    let isValid = keyArray.every((keyString) => keyString in fileResult[0]);
    return isValid;
  }
	resetFormFacturacion() {
		this.validFile = false;
		this.dteFileForm.reset();
		this.files = [];
		this.fileData = [];
		this.invalidColumns = [];
	}

	setEmisorToElement(row: ImportacionMasivaBHE) {
		let empresaAsociada = this.empresasSource.find((Emisor) => Emisor.emisorId == row.idEmisor);
		row.emisor = empresaAsociada;
	}

	sortByProperty(rowsOfDocumentos: any[], propertyKey: string): any[] {
		var groupBy = function (rowsOfDocumentos, propertyKey) {
			return rowsOfDocumentos.reduce(function (rv, x) {
				(rv[x[propertyKey]] = rv[x[propertyKey]] || []).push(x);
				return rv;
			}, {});
		};
		return groupBy(rowsOfDocumentos, propertyKey);
	}

	sumArrayProperty(arrayToSum: Array<any>, propertyToSum: string) {
		let sum: number = 0;
		let auxValue;
		arrayToSum.forEach((detailRow) => {
			auxValue = detailRow[propertyToSum];
			if (!Number.isNaN(auxValue) && auxValue != undefined && auxValue != '') {
				sum += parseFloat(auxValue);
			}
		});
		return sum;
	}

	getSumAfectosExentos(arrayToSum: Array<any>, propertyToSum: string): [number, number] {
		let sumaNetoAfecto = 0;
		let sumaExento = 0;
		let auxValue;
		try {
			arrayToSum.forEach((detailRow) => {
				auxValue = detailRow[propertyToSum];
				if (!Number.isNaN(auxValue) && auxValue != undefined && auxValue != '') {
					sumaNetoAfecto += parseFloat(auxValue);
				}
			});
		} catch (error) {
			console.log(error);
			Swal.fire({
				icon: "error",
				title: "Error en lectura",
				text: "Se ha producido un error al leer los datos del documento." + error,
			});
		}

		return [sumaNetoAfecto, sumaExento];
	}

	//Formato debe contener:
	//numero de columnas, nombre de las columnas , formato de las columnas
	ordenarPorFecha(lista: ImportacionMasivaBHE[]) {
		lista.sort((a: ImportacionMasivaBHE, b: ImportacionMasivaBHE) => {
			return new Date(b.fechaCarga).getTime() - new Date(a.fechaCarga).getTime();
		});
	}

	chosenYearHandler(normalizedYear: Moment) {
		let ctrlValue = moment(this.dateFrom);
		ctrlValue.year(moment(normalizedYear).year());
		this.dateFrom = moment(ctrlValue);
		this.ref.detectChanges();
	}

	chosenMonthHandler(normalizedMonth: Moment, datepicker: OwlDateTimeComponent<Moment>) {
		let ctrlValue = moment(this.dateFrom);
		ctrlValue.month(moment(normalizedMonth).month());
		this.dateFrom = moment(ctrlValue);
		this.ref.detectChanges();
		datepicker.close();
	}
	chosenYearHandlerDateTo(normalizedYear: Moment) {
		let ctrlValue = moment(this.dateTo);
		ctrlValue.year(moment(normalizedYear).year());
		this.dateTo = moment(ctrlValue);
		this.ref.detectChanges();
	}

	chosenMonthHandlerDateTo(normalizedMonth: Moment, datepicker: OwlDateTimeComponent<Moment>) {
		let ctrlValue = moment(this.dateTo);
		ctrlValue.month(moment(normalizedMonth).month());
		this.dateTo = moment(ctrlValue);
		this.ref.detectChanges();
		datepicker.close();
	}

	getMonthYear(date: Date) {
		return moment(date).month() + "," + moment(date).year();
	}

	detectChangeStartDate(event) {
		let fromDate = moment();
		if (event.target != null) {
			fromDate = moment((<HTMLInputElement>event.target).value, "DD/MM/YYYY");
			this.dateFrom.startDate = fromDate;
		}
	}
	detectChangeEndDate(event) {
		let toDate = moment();
		if (event.target != null) {
			toDate = moment((<HTMLInputElement>event.target).value, "DD/MM/YYYY");
			this.dateTo.endDate = toDate;
		}
	}

	setPageSize() {
		//this.page.currentPageSize = this.page.page
		this.setPage({ offset: 0 });
	}
	setPage(pageInfo, $event?) {
		if ($event) {
			this.filter.fechaDesde = $event.fechaInicio;
			this.filter.fechaHasta = $event.fechaFin;
			this.filter.origen = $event.origenImportacion;
			this.filter.sucursalId = $event.sucursalId ? $event.sucursalId : this.currentSucursal;
			this.filter.emisorId = $event.emisorId ? $event.emisorId : this.emisorId;
		}
		this.loading = true;
		this.page.pageNumber = pageInfo.offset;
		let localPage = JSON.parse(JSON.stringify(this.page));
		localPage.pageNumber += 1;
		//this.page.pageNumber +=1;

    if (this.fileIdValue) {
			//llamada con fileIdValue al endpoint de lista paginada
			// this.bheService
			// 	.getDataByPage(this.filter, localPage)
			// 	.subscribe(
			// 		(pagedData) => {
			// 			let elements = pagedData.data as DteEmitido[];
			// 			this.ref.detectChanges();
			// 			elements.forEach((row) => {
			// 				this.setEmisorToElement(row);
			// 				this.setTipoDteToElement(row);
			// 			});
			// 			this.rowsMantenedor = [...elements];

			// 			this.ref.detectChanges();
			// 			this.setPagefromResponse(this.page, pagedData);
			// 			this.loading = false;
			// 			this.componentStarted = true;
			// 			this.ref.detectChanges();
			// 		},
			// 		(error) => {
			// 			this.currentSwal.icon = "error";
			// 			this.currentSwal.title = "Error en la solicitud";
			// 			this.currentSwal.text = this.utilities.setErrorMessageFromArray(error.error);
			// 			this.currentSwal.fire();
			// 		},
			// 		() => {
			// 			this.loading = false;
			// 			this.ref.detectChanges();
			// 		}
			// 	)
			// 	.add(() => {
			// 		this.loading = false;
			// 		this.ref.detectChanges();
			// 	});
		}
    else {
      this.bheService
			.getDataByPage(this.filter, localPage)
			.subscribe(
				(result) => {
					let elements = result.data as ImportacionMasivaBHE[];
					elements.forEach((row) => {
						this.setEmisorToElement(row);
						//this.setTipoArchivoToElement(row);
						row.fechaCarga = moment(row.fechaCarga);
					});
					this.ordenarPorFecha(elements);
					if (elements) {
						this.rowsMantenedor = [...elements];
					}
					this.ref.detectChanges();

					this.setPageFromResponse(this.page, result);
					this.ref.detectChanges();
				},
				(error) => {
					this.setSwalAndFire(this.currentSwal, "error", "Error en solicitud", "No es posible obtener los datos.\nDetalle: " + this.utilities.setErrorMessageFromArray(error.error));
				}
			)
			.add(() => {
				this.loading = false;
				this.componentStarted = true;
				this.ref.detectChanges();
			});
    }
	}

	setPageFromResponse(currentPage: Page, data: PagedResponse<ImportacionMasivaBHE>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < -1 ? 0 : data.pageNumber - 1;

		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	getSample() {
		this.loading = true;
		this.bheService.downloadSample().subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				let filename = "ejemplo_carga_masiva_bhe.csv";
				let dataType = res.type;
				let binaryData = [];
				binaryData.push(res);
				let blob = new Blob(binaryData, { type: dataType });
				let downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
				downloadLink.setAttribute("download", filename);
				document.body.appendChild(downloadLink);
				downloadLink.click();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en Ejemplo",
					text: "No fue posible obtener el archivo de ejemplo, intente nuevamente.",
				});
			}
		);
	}

	downloadInstructions() {
		this.loading = true;
		this.bheService.getPdfInstructions().subscribe(
			(result) => {
				this.PdfDownload(result.data, "Instrucciones Facturación Masiva");
				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Descargar Pdf",
					text: "No fue posible descargar el pdf de instrucciones de facturación masiva, intentar nuevamente." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	CsvDataToObjects(data: any[]): Object[] {
		let results = [];
		var headersLine: string[] = Object.values(data[0]);
		var dataLines: string[] = [];
		var headers = headersLine[0].split(";");
		data.shift();
		data.forEach((element) => {
			let dataline: string[] = Object.values(element);
			let dataArray = dataline[0].split(";");
			let obj = {};
			for (let index = 0; index < dataArray.length; index++) {
				obj[headers[index]] = dataArray[index];
			}
			results.push(obj);
		});
		return results;
	}

	concatValuesToObjProperty(obj, propertyToSet, propertyToGet) {
		let arrayValues = [];
		if (obj[propertyToGet]) {
			let arrayPropertiesToConcat = obj[propertyToGet].forEach((element) => (obj[propertyToSet] += element));
			obj[propertyToSet] += arrayPropertiesToConcat;
		}
	}

	detectChangeDate(event) {
		let fromDate = moment();
		if (event.startDate != null) {
			this.dateMatrixRequest = event;
		}
		if (event.target != null && event.target.value != null) {
			this.validDate = moment(event.target.value, "DD/MM/YYYY", true).isValid();
			if (this.validDate) {
				fromDate = new Object();
				fromDate.startDate = moment(event.target.value, "DD-MM-YYYY");
				this.dateMatrixRequest = fromDate;
			}
		}
	}

	toggleExpandRow(row) {
		this.tableRef.rowDetail.toggleExpandRow(row);
	}

	PdfDownload(responseB64, name) {
		const pdfBlob = this.utilities.convertB64ToBlob(responseB64, "text/pdf");
		FileSaver.saveAs(pdfBlob, name + ".pdf");
		this.loading = false;
		this.ref.detectChanges();
	}

	downloadGlossary() {
		this.loading = true;
		this.bheService.getPdfGlossary().subscribe(
			(result) => {
				this.PdfDownload(result.data, "Glosario");
				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Descargar Pdf",
					text: "No fue posible descargar el pdf de glosario, favor recargar intentar nuevamente." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	checkConflictInDelimiter(result: ParseResult) {
		let containsSeparator = Object.keys(result.data[0] as string).some((n) => n.includes(";"));
		return containsSeparator;
	}

	getEmisoresFullList() {
		this.emisorService.getData().subscribe(
			(result) => {
				let emisores = result.data;
				this.empresasSource = emisores;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en emisores",
					text: "No fue posible obtener la lista de emisores completa, tiene disponible solamente los emisores ya presentes en el selector de empresas." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

}
